import getUpsellFunnelStep from './getUpsellFunnelStep';
import setUpsellSession from './setUpsellSession';

export default function storeUpsellSession(payment, checkout, sellerId, cookies) {
  const isSubscription = checkout.product.type === 'subscription';
  const isCharge = checkout.product.type === 'charge';

  const upsellFunnelStep = getUpsellFunnelStep(checkout);

  setUpsellSession(
    {
      initialCheckoutId: checkout._id,
      initialSellerId: sellerId,
      ...(isSubscription && { initialSubscriptionId: payment._id }),
      ...(isCharge && { initialPaymentId: payment._id }),
      customerId: payment.customer._id,
      upsell: upsellFunnelStep.config, // Use .config directly
    },
    cookies,
  );
}
